// Shows "Updated — tap to refresh" when a newer app build has been published.
import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const BUNDLE_RE = /\/static\/js\/main\.[a-f0-9]+\.js/;
const CHECK_MS = 5 * 60 * 1000;

const currentBundle = () => {
  const s = Array.from(document.scripts).find((el) => BUNDLE_RE.test(el.src || ''));
  return s ? s.src.match(BUNDLE_RE)[0] : null;
};

const refresh = async () => {
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    await reg?.update();
  } catch { /* reload anyway */ }
  window.location.reload();
};

export const UpdateBanner = () => {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return undefined; // dev server: no hashed bundle
    const check = async () => {
      if (document.visibilityState !== 'visible') return;
      try {
        const html = await (await fetch(`/?__version_check=${Date.now()}`, { cache: 'no-store' })).text();
        const live = html.match(BUNDLE_RE)?.[0];
        if (live && live !== mine) setStale(true);
      } catch { /* offline — try later */ }
    };
    const id = setInterval(check, CHECK_MS);
    document.addEventListener('visibilitychange', check);
    window.addEventListener('focus', check);
    check();
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', check);
      window.removeEventListener('focus', check);
    };
  }, []);

  if (!stale) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-full bg-blue-600 text-white shadow-lg px-4 py-2 text-sm"
      data-testid="app-update-banner">
      <span>Updated — a new version is available</span>
      <button type="button" onClick={refresh} data-testid="app-update-refresh-btn"
        className="inline-flex items-center gap-1 rounded-full bg-white text-blue-700 px-3 py-1 font-medium hover:bg-blue-50">
        <RefreshCw className="w-3.5 h-3.5" /> Tap to refresh
      </button>
    </div>
  );
};
